module.exports = __webpack_public_path__ + "img/fing_flag.e2b7cef1.png";